// 多语言和多国家
const reg = /\/(nl|cn)/
const nlReg = /\/nl/
let langCache
let langPathCache
export default function getLang() {
  if (langCache) return langCache
  const url = location.pathname
  const lang = url.match(reg)
  langCache = lang ? (url.match(nlReg) ? 'nl' : 'zh') : 'en'
  langPathCache = lang ? (url.match(nlReg) ? 'nl/' : `cn/`) : 'en/'
  return langCache
}
export function getLangPath() {
  if (!langPathCache) getLang()
  return `${langPathCache}`
}


// WEBPACK FOOTER //
// ./resources/js/lib/i18n/getLang.js